import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Location} from "@angular/common";
import {passwordPolicyValidator} from "../../shared/validators/input-validators";
import {Apollo} from "apollo-angular";
import {CITIZEN_GET_SEARCHED_SERVICES} from "../portal/portal-home/portal-home";
import {of} from "rxjs";
import {CHANGE_PASSWORD} from "./change-password.graphql";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  title: string;

  hidePassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private location: Location,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private authService: AuthService,
  ) {
  }


  ngOnInit(): void {
    this.form = this.fb.group(
      {
        oldPassword: [null, [Validators.required]],
        newPassword: [null, [Validators.required, passwordPolicyValidator()]],
        confirmPassword: [null, [Validators.required, passwordPolicyValidator()]],
      }
    );
  }

  submitForm(formValue: { oldPassword: string; newPassword: string; confirmPassword: string; }) {
    this.apollo
      .mutate({
        mutation: CHANGE_PASSWORD,
        fetchPolicy: 'network-only',
        variables: {
          input: {
            oldPassword: formValue.oldPassword,
            newPassword: formValue.newPassword,
          }
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.changePassword;
        if (result?.response.status) {
          this.notificationService.successMessage(result?.response.message).then(() => this.authService.logout())
        } else {
          this.notificationService.errorMessage(result?.response.message).then()
        }
      });
  }

  goBack() {
    this.location.back();
  }

}
